import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Heart, Mail, Phone } from 'lucide-react';

export default function Footer() {
  const resources = [
    ['ABDM', '/abdm'],
    ['ABHA Card', '/abha-card'],
    ['PHR Apps', '/phr-apps'],
  ];
  const quickLinks = [
    ['Home', '/'],
    ['Talk to Buddy', '/chat'],
    ['My Reports', '/history'],
    ['Doctor Portal', '/doctor/login'],
  ];
  const legalLinks = [
    ['Privacy Policy', '/privacy'],
    ['Terms of Service', '/terms'],
  ];

  return (
    <footer className="mt-20 border-t border-[#E8E1D5] bg-[#F4F1EA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Heart className="h-5 w-5 text-[#E07A5F]" fill="#E07A5F" />
            <span className="font-display text-xl text-[#1E3F33]">Health Buddy</span>
          </div>
          <p className="text-[15px] text-[#4A4A4A] max-w-sm">
            A caring AI health companion for every village, every language, every family. Not a replacement for a doctor; a friend that listens first.
          </p>
        </div>

        <div>
          <div className="font-semibold text-[#1E3F33] mb-3">Resources</div>
          <ul className="space-y-2 text-[15px] text-[#4A4A4A]">
            {resources.map(([label, href]) => (
              <li key={href}>
                <Link to={href} className="hover:text-[#1E3F33] hover:underline">
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="https://abdm.gov.in/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 hover:text-[#1E3F33] hover:underline"
              >
                Official ABDM <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-semibold text-[#1E3F33] mb-3">Quick Links</div>
          <ul className="space-y-2 text-[15px] text-[#4A4A4A]">
            {quickLinks.map(([label, href]) => (
              <li key={href}>
                <Link to={href} className="hover:text-[#1E3F33] hover:underline">
                  {label}
                </Link>
              </li>
            ))}
            {legalLinks.map(([label, href]) => (
              <li key={href}>
                <Link to={href} className="hover:text-[#1E3F33] hover:underline">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-semibold text-[#1E3F33] mb-3">Reach us</div>
          <ul className="space-y-2 text-[15px] text-[#4A4A4A]">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> +91 00000 00000</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> care@healthbuddy.ai</li>
          </ul>
          <div className="font-semibold text-[#1E3F33] mt-6 mb-3">Important</div>
          <p className="text-sm text-[#7A7A7A]">
            Health Buddy provides informational guidance only. In an emergency, contact your nearest hospital or call your local emergency number.
          </p>
        </div>
      </div>
      <div className="border-t border-[#E2E8F0] py-4 text-center text-xs text-[#7A7A7A]">
        <span>{new Date().getFullYear()} Health Buddy - Made with care</span>
        <span className="mx-2">·</span>
        <Link to="/privacy" className="hover:text-[#1E3F33] hover:underline">Privacy</Link>
        <span className="mx-2">·</span>
        <Link to="/terms" className="hover:text-[#1E3F33] hover:underline">Terms</Link>
      </div>
    </footer>
  );
}
